import { lazy, Suspense } from 'react'
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom"

import { LazySpinner } from '../../app/shared/spinner/Spinner'

const ChangePasswordPage = lazy(() => import('../../app/auth/pages/ChangePasswordPage'))
const LoginPage = lazy(() => import('../../app/auth/pages/LoginPage'))
const RecoverPasswordPage = lazy(() => import('../../app/auth/pages/RecoverPasswordPage'))
const RegisterPage = lazy(() => import('../../app/auth/pages/RegisterPage'))

const AuthRoutes = () => {

    const { path } = useRouteMatch()

    return (

        <Suspense fallback={<LazySpinner />}>
            <Switch>
                <Route exact path={`${path}/login`} component={LoginPage} />

                <Route exact path={`${path}/register`} component={RegisterPage} />

                <Route exact path={`${path}/recover-password`} component={RecoverPasswordPage} />

                <Route exact path={`${path}/recover-password/:tokenrecoverpassword`} component={ChangePasswordPage} />

                <Redirect to={ `${ path }/login` }/>
            </Switch>
        </Suspense>

    )

}

export default AuthRoutes